import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import Approach from "@/pages/Approach";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import OnlineTimetable from "@/pages/OnlineTimetable";
import Locations from "@/pages/Locations";
import AdminEnquiries from "@/pages/AdminEnquiries";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="courses" element={<Courses />} />
          <Route path="approach" element={<Approach />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="online-timetable" element={<OnlineTimetable />} />
          <Route path="locations" element={<Locations />} />
          <Route path="admin/enquiries" element={<AdminEnquiries />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
